import { render } from "./ChapterProgression.vue?vue&type=template&id=f6490612"
import script from "./ChapterProgression.vue?vue&type=script&lang=js"
export * from "./ChapterProgression.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__